import { isDifferentObject } from "./isDifferentObject";
import { preferStableObjectReferenceNullable } from "./preferStableObjectReferenceNullable";
/**
 * Keep a stable references to objects in an array.
 * @param previous
 * @param current
 * @returns A new array with
 */
export function preferStableObjectReferenceArray(previous, current) {
    // edge case: do not create new array
    if (previous == current) {
        return current;
    }
    // edge case: they are the same
    if (!isDifferentObject(previous, current)) {
        return previous;
    }
    // try to preserve object references by position
    return current.map((item, itemIndex) => preferStableObjectReferenceNullable(previous[itemIndex], item));
}
//# sourceMappingURL=preferStableObjectReferenceArray.js.map